import React from 'react';
import './Plasticizinglways.css';
import plasal from '../../../imgs/plasalway.webp';


const Plasticizinglways = () => {
    return (
        <div className="Material-container">
            <div className='Materialsl'>
                <h2 className="Material-title">Disha  Plasticizing The Beautiful World, Always For You!</h2>
                 <p className="Material-text">See you in </p>
                <p className="Material-date">Düsseldorf, 19-26 October!</p>
                <p className="Material-text">Come and meet us at</p>
                <p className="Material-date">Booth D39 in Hall 13.</p>
                                <p className="Material-text">Join us and learn more about how we can solve 
                                    your injection molding and extrusion blow molding problem.</p>

                <div className="advantpl">
                    <img src={plasal} alt="72 Cavity PET Preforms Machine" className="advantpla-image" />
                </div>
             
            </div>
        </div>
    );
};
export default Plasticizinglways;
